


















import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import WeeklyRuleForm, { DEFAULT_WEEKLY_RRULE } from './WeeklyRuleForm'
import { RRule } from 'rrule'

settings =
  name: 'OnsiteInputFormModal'

  vue:
    props: ['modal', 'actions']

    components: {
      Modal,
      WeeklyRuleForm,
    }

    data: ->
      freq: RRule.WEEKLY
      form: @defaultFormData()

    computed:
      show: -> @modal.show
      startDay: -> @form.startDay
      occurrenceTypes: ->
        [
          { label: 'Weekly', value: RRule.WEEKLY },
          { label: 'Monthly', value: RRule.MONTHLY },
          { label: 'Annually', value: RRule.YEARLY },
        ]

    methods:
      close: ->
        @modal.show = false

      add: ->
        @actions.addCalendarEvent @form
        @close()

      update: ->
        @actions.updateCalendarEvent @form
        @close()

      configModal: ->
        @form = { ...@defaultFormData(), ...@modal.config }
        @freq = @form.rrule.freq if @form.rrule?.freq

      defaultFormData: ->
        title: '',
        startDay: ''
        endDay: ''

        repeats: true
        seasonal: false
        rrule: { ...DEFAULT_WEEKLY_RRULE }

    watch:
      show: (value) ->
        @configModal() if value

      freq: (value) ->
        @form.seasonal = false if value is RRule.YEARLY

        rules =
          [RRule.WEEKLY]: DEFAULT_WEEKLY_RRULE
        @form.rrule = rules[value]

      startDay: (value) ->
        @form.rrule.dtstart = new Date value

export default VueOptions.vue settings
